import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityHeader = ({ securityScore }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreLabel = (score) => {
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    return 'Needs Improvement';
  };

  return (
    <div className="bg-gradient-to-r from-primary to-secondary text-white rounded-lg p-6 md:p-8 lg:p-10 mb-6 md:mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-white/20 rounded-full flex items-center justify-center">
              <Icon name="Shield" size={28} color="#FFFFFF" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold">Security Center</h1>
              <p className="text-sm md:text-base opacity-90">Comprehensive account protection and monitoring</p>
            </div>
          </div>
          <p className="text-sm md:text-base opacity-80 max-w-2xl">
            Manage your account security settings, monitor device access, and review security events. Your digital assets are protected with bank-level encryption and multi-factor authentication.
          </p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 min-w-[200px] md:min-w-[240px]">
          <div className="text-center">
            <div className="text-xs md:text-sm opacity-80 mb-2">Security Score</div>
            <div className={`text-4xl md:text-5xl lg:text-6xl font-bold ${getScoreColor(securityScore)}`}>
              {securityScore}
            </div>
            <div className="text-sm md:text-base mt-2">{getScoreLabel(securityScore)}</div>
            <div className="mt-4 pt-4 border-t border-white/20">
              <div className="text-xs opacity-70">Last Updated</div>
              <div className="text-sm font-medium">Jan 12, 2026</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityHeader;